// サーバー/クライアント両安全な単一設定リスト（docs/design.md §10・CLAUDE.md「多言語対応」）。
// 言語追加は「リソースJSON追加 + このファイルに1行」のみで完結させる。コード中のロケール分岐は禁止。

export const validLocales = ["ja", "en"] as const;
export type Locale = (typeof validLocales)[number];

export const defaultLocale: Locale = "ja";

export const localeNativeNames: Record<Locale, string> = {
  ja: "日本語",
  en: "English",
};

export function isValidLocale(value: string): value is Locale {
  return (validLocales as readonly string[]).includes(value);
}
